import {createFetchListReducer} from 'common/reducers/utils';
import {
  UPDATE_RIDE,
  UPDATE_RIDE_REQUEST,
  CLEAR_RIDE_REQUEST,
  REQUEST_CANCEL_RIDE,
  RECEIVE_CANCEL_RIDE,
  RECEIVE_CANCEL_RIDE_ERROR,
  CLEAR_CANCEL_RIDE_ERROR,
} from 'ondemand/actions/ride';

const defaultRideRequest = {
  pickup: null,
  pickupName: null,
  pickupDateTime: null,
  dropoff: null,
  dropoffName: null,
  capacity: null,
  wheelchair: null,
  isConfirmed: false,
  isFetching: false,
  errors: null,
};

const defaultReducer = createFetchListReducer({
  name: 'ride',
});

export default function rides(
  state = {
    error: null,
    isFetching: false,
    items: null,
    rideRequest: defaultRideRequest,
  },
  action,
) {
  switch (action.type) {
    case REQUEST_CANCEL_RIDE:
      return Object.assign({}, state, {isFetching: true});
    case RECEIVE_CANCEL_RIDE:
      return Object.assign({}, state, {
        isFetching: false,
        items: Object.assign({}, state.items, {[action.ride.rideId]: action.ride}),
      });
    case RECEIVE_CANCEL_RIDE_ERROR:
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error,
      });
    case CLEAR_CANCEL_RIDE_ERROR:
      return Object.assign({}, state, {error: null});
    case UPDATE_RIDE:
      return Object.assign({}, state, {
        items: Object.assign({}, state.items, {[action.ride.rideId]: action.ride}),
      });
    case UPDATE_RIDE_REQUEST:
      return Object.assign({}, state, {
        rideRequest: Object.assign({}, state.rideRequest, action.rideRequest),
      });
    case CLEAR_RIDE_REQUEST:
      return Object.assign({}, state, {rideRequest: defaultRideRequest});
    default:
      return defaultReducer(state, action);
  }
}



// WEBPACK FOOTER //
// ./src/ondemand/reducers/ride.js